import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionComponent } from './bancreachwebsite/pages/subscription/subscription.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./bancreachwebsite/bancreachwebsite.module').then(m => m.BancreachwebsiteModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
